import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {OdfForm} from ".";

type PreviewProps = {
    test: Test
}

export class OdfRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <OdfForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}